import type { VoteSession } from '../../models'

// Each vote entry: [slug, VoteSession, type_label]
export type VoteEntry = [string, VoteSession, string]

/**
 * Group an array of vote entries by their date field.
 * Preserves insertion order; groups are in the order the first vote for that date appeared.
 */
export function groupVotesByDate(votes: VoteEntry[]): [string, VoteEntry[]][] {
  const groups: [string, VoteEntry[]][] = []
  for (const item of votes) {
    const date = item[1].date
    const existing = groups.find(([d]) => d === date)
    if (existing) {
      existing[1].push(item)
    } else {
      groups.push([date, [item]])
    }
  }
  return groups
}

/**
 * Return a human-readable explanation for a vote type string.
 * Mirrors Rust's vote_type_explanation.
 */
export function voteTypeExplanation(vtype: string): string {
  switch (vtype) {
    case 'Particular · Norma específica':
      return 'Votación de una norma específica, artículo o indicación. Su rechazo no implica rechazar todo el proyecto.'
    case 'Admisibilidad':
      return '¿Es válida esta propuesta de cambio? Si se rechaza, la propuesta se descarta sin debate.'
    case 'Particular':
      return 'Votación artículo por artículo. Cada ítem se vota por separado.'
    case 'General':
      return '¿Se aprueba el proyecto en su totalidad?'
    case 'Única':
      return 'Votación única cuando no hay debate separado por artículos.'
    default:
      return 'Votación en sala.'
  }
}

/**
 * Group an array of vote entries by the type_label field (third tuple element).
 * Preserves insertion order; groups are in the order the first vote for that type appeared.
 */
export function groupVotesByType(votes: VoteEntry[]): [string, VoteEntry[]][] {
  const groups: [string, VoteEntry[]][] = []
  for (const item of votes) {
    const vtype = item[2]
    const existing = groups.find(([t]) => t === vtype)
    if (existing) {
      existing[1].push(item)
    } else {
      groups.push([vtype, [item]])
    }
  }
  return groups
}
